import React, { useContext } from "react";
import { RespiratoryInitialContext } from "./RespiratoryTherapistInitialAssessmentProvider";
import { Col, Row, Tag } from "antd";
import DrClinicalImpressionSummary from "../../InspectionSummaries/ClinicalImpressionSummary/DrClinicalImpressionSummary";
import RespiratoryTreatmentPlanSummary from "../../InspectionSummaries/TreatmentPlan/RespiratoryTreatmentPlanSummary";
import RespiratoryChartAssessmentSummary from "../../InspectionSummaries/ChartAssessment/RespiratoryChartAssessmentSummary";
import PatientAssessmentSummary from "../../InspectionSummaries/PatientAssessment/PatientAssessmentSummary";
import RespiratorySpecialInstructionSummary from "../../InspectionSummaries/Special/RespiratorySpecialInstructionSummary";
import { checkEmpty } from "../../../../helpers/utility";
import dayjs from "dayjs";
import "../../summary.css";

const RespiratoryTherapistInspectionSummary = ({ hideMeta = false }) => {
  const { formData } = useContext(RespiratoryInitialContext);
  return (
    <Row className="summaries" gutter={[16, 16]}>
      {!hideMeta && (
        <Col span={24}>
          <div className="ia-summary-meta-bar">
            {(formData?.submitted_by_first_name ||
              formData?.submitted_by_last_name) && (
              <Tag className="ia-summary-meta-tag ia-summary-meta-tag--submitted">
                Submitted by: {formData?.submitted_by_first_name || ""}{" "}
                {formData?.submitted_by_last_name || ""}
              </Tag>
            )}
            <div className="ia-summary-meta-bottom">
              {formData?.updated_at && (
                <Tag className="ia-summary-meta-tag ia-summary-meta-tag--updated">
                  Updated at:{" "}
                  {dayjs(formData?.updated_at).format("DD/MM/YYYY hh:mm A")}
                </Tag>
              )}
            </div>
          </div>
        </Col>
      )}
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.clinical_diagnosis) && (
          <DrClinicalImpressionSummary
            context={RespiratoryInitialContext}
            formData={formData}
          />
        )}
        {checkEmpty(formData?.treatment_plan) && (
          <RespiratoryTreatmentPlanSummary
            formData={formData}
            context={RespiratoryInitialContext}
          />
        )}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.chart_assessment) && (
          <RespiratoryChartAssessmentSummary formData={formData} />
        )}

        {checkEmpty(formData?.patient_assessment) && (
          <PatientAssessmentSummary formData={formData} />
        )}
        {checkEmpty(formData?.special_instruction) && (
          <RespiratorySpecialInstructionSummary formData={formData} />
        )}
      </Col>
    </Row>
  );
};

export default RespiratoryTherapistInspectionSummary;
